import styled from "styled-components";

const colors = {
    primary: "#0052CC",
    background: "#f8f9fa",
    cardBackground: "#FFFFFF",
    textPrimary: "#172B4D",
    textSecondary: "#6B778C",
    border: "#DFE1E6",
    danger: "#dc3545",
};

const bp = {
    lg: 1200,
    md: 992,
    sm: 768,
    xs: 576,
};

export const PageContainer = styled.div`
  background-color: ${colors.background};
  padding: 32px 24px;
  min-height: 100%;

  @media (max-width: ${bp.sm}px) {
    padding: 20px 16px;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: ${colors.textPrimary};

  @media (max-width: ${bp.sm}px) {
    font-size: 24px;
  }
`;

export const Actions = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

export const Card = styled.div`
  background-color: ${colors.cardBackground};
  border: 1px solid ${colors.border};
  border-radius: 12px;
  box-shadow:
    0 4px 8px -2px rgba(9, 30, 66, 0.1),
    0 0 1px rgba(9, 30, 66, 0.08);
  overflow: hidden;
`;

export const CardHeader = styled.div`
  padding: 20px 24px;
  border-bottom: 1px solid ${colors.border};
`;

export const CardTitle = styled.h2`
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: ${colors.textPrimary};
`;

export const CardBody = styled.div`
  padding: 24px;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(260px, 1fr));
  gap: 16px;

  @media (max-width: ${bp.md}px) {
    grid-template-columns: 1fr;
  }
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FieldFull = styled(Field)`
  grid-column: 1 / -1;
`;

export const Label = styled.label`
  font-size: 12px;
  font-weight: 700;
  color: ${colors.textSecondary};
  letter-spacing: 0.2px;
`;

export const Input = styled.input`
  height: 42px;
  border: 1px solid ${colors.border};
  border-radius: 8px;
  padding: 0 12px;
  outline: none;
  font-size: 14px;
  color: ${colors.textPrimary};
  background: #fff;
  width: 100%;

  &:focus {
    border-color: ${colors.primary};
    box-shadow: 0 0 0 3px rgba(0, 82, 204, 0.12);
  }
`;

export const ReadOnlyInput = styled(Input)`
  background: #f7f8fa;
  color: ${colors.textSecondary};
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 24px;
`;

export const InfoText = styled.div`
  font-size: 13px;
  color: ${colors.textSecondary};
  margin-top: 8px;
`;

export const ErrorText = styled.div`
  font-size: 13px;
  color: ${colors.danger};
  margin-top: 4px;
`;